// Generated from source/ by scripts/generate.ts. Do not edit by hand.
import type { IconData } from "../types.js";

const m0 =
  '<path d="M12 2C17.52 2 22 6.48 22 12S17.52 22 12 22 2 17.52 2 12 6.48 2 12 2M11 10A1 1 0 1 0 11 12V17A1 1 0 0 0 12 18H12.5A1 1 0 0 0 13 16.14V11A1 1 0 0 0 12 10ZM12 7A1 1 0 1 0 12 9L12 9A1 1 0 0 0 12 7Z"/>';

/** Info (status). */
const icon: IconData = {
  id: "info",
  name: "Info",
  category: "status",
  styles: {
    rounded: { svg: m0 },
    sharp: { svg: m0 },
    outline: {
      svg: '<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8L12 8M11 11H12V17H12.5M21 12A9 9 0 1 1 3 12 9 9 0 0 1 21 12"/>',
    },
    duotone: {
      svg: '<g opacity=".32"><path d="M11.9 2L14.11 2.23 15.98 2.83 17.67 3.77 19.14 5 20.34 6.49 21.25 8.2 21.81 10.09 22 12.1 21.77 14.11 21.17 15.98 20.23 17.67 19 19.14 17.51 20.34 15.8 21.25 13.91 21.81 11.9 22 9.89 21.77 8.02 21.17 6.33 20.23 4.87 19 3.66 17.51 2.75 15.8 2.19 13.91 2 11.9 2.23 9.89 2.83 8.02 3.77 6.33 5 4.87 6.49 3.66 8.2 2.75 10.09 2.19Z"/></g><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8L12 8M11 11H12V17H12.5M21 12A9 9 0 1 1 3 12 9 9 0 0 1 21 12"/>',
    },
  },
  animation: () => import("../animations/info.js"),
};

export default icon;
